<template id="child">
  <div v-show="showModal" :style="cssProps">
    <div class="modal d-flex flex-column">
      <h1>Add a New Credit Card</h1>
       <div class="column-input d-flex flex-column justify-content-around">
            <input type="text" placeholder="Full name" name="fullname" v-validate="'required'">
            <span class="not-work">{{ errors.first('fullname') }}</span>
             <input type="text" placeholder="Enter your credit card number" name="creditcard" id="creditcard" v-model="cardInfo.cardnumber" maxlength="19" v-validate="'required|credit_card|max:19'" @input="transformCard">
             <span class="not-work">{{ errors.first('creditcard') }}</span>
             <div class="row-input d-flex flex-row justify-content-between">
               <div class="d-flex flex-column">
                 <input type="text" placeholder="MM/YY" v-model="expirydate" id="expdate" name="expdate" v-validate="'required|date_format:MM/DD'" maxlength="5" @input="transformDate">
                <span class="not-work">{{ errors.first('expdate') }}</span>
               </div>
               <div class="d-flex flex-column">
                 <input type="password" placeholder="CVC Code" v-model="cardInfo.cvv" id="cvc" name="cvc" v-validate="'required|max:3'" maxlength="3">
                <span class="not-work">{{ errors.first('cvc') }}</span>
               </div>

             
             </div>
       </div>
        <div class="button d-flex flex-row justify-content-between">
                <button @click="hide">
                    <span>Cancel</span>
                </button>
                <button @click="submit">
                    <span>Add</span>
                </button>
            </div>
    </div>
    <div class="modal-overlay"></div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  template: "#child",
  $_veeValidate: {
    validator: 'new', 
  },
  data() {
    return {
      showModal: false,
      fullname: null,
      cardInfo: {
        cardnumber: null,
        expiryyear: null,
        expirymonth: null,
        cvv: null
      },
      expirydate: null
    };
  },
  computed: {
    ...mapState(['info']),
		cssProps() { return {
        '--main-color': this.info.color ? "#" + this.info.color : "#c12d39"
      }
    },
	},
  methods: {
    show() {
      this.showModal = true;
    },
    hide() {
      this.showModal = false;
      this.cardInfo.cardnumber = null;
      this.cardInfo.expiryyear = null;
      this.cardInfo.expirymonth = null;
      this.cardInfo.cvv = null;
      this.expirydate = null;
      this.fullname = null;
    },
    async submit(){
      const checking = await this.$validator.validateAll();
      console.log(checking)
      if(checking){
        this.$emit('submit', this.cardInfo, this.fullname);
        this.cardInfo = {cardnumber: null, expiryyear: null, expirymonth: null, cvv: null};
        this.expirydate = null;
        this.showModal = false;
      }
    },
    transformDate(){
       var foo = this.expirydate.split("/").join(""); 
        if (foo.length > 0) {
          foo = foo.match(new RegExp('.{1,2}', 'g')).join("/");
        }
        this.expirydate = foo;
      // let parts = this.expirydate.split('/');
      // this.cardInfo.expirymonth = parts[0];
      // this.cardInfo.expiryyear = parts[1];
    },
    transformCard(){
        var foo = this.cardInfo.cardnumber.split(" ").join(""); 
        if (foo.length > 0) {
          foo = foo.match(new RegExp('.{1,4}', 'g')).join(" ");
        }
        this.cardInfo.cardnumber = foo;
    },
    setInputFilter(textbox, inputFilter) {
      ["input", "keydown", "keyup", "mousedown", "mouseup", "select", "contextmenu", "drop"].forEach(function(event) {
        textbox.addEventListener(event, function() {
          // console.log(this.value)
          if (inputFilter(this.value)) {
            this.oldValue = this.value;
            this.oldSelectionStart = this.selectionStart;
            this.oldSelectionEnd = this.selectionEnd;
          } else if (this.hasOwnProperty("oldValue")) {
            if(this.value !== ""){
              this.value = this.oldValue;
              this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
            }
            else{
              this.value = "";
            }
          }
          else{
            this.value = "";
          }
        });
      });
    }
  },
  mounted(){
    this.setInputFilter(document.getElementById("creditcard"), function(value) {
      return /^[0-9 ]+$/.test(value);
    });
    this.setInputFilter(document.getElementById("expdate"), function(value) {
      return /^[0-9/]+$/.test(value);
    });
    this.setInputFilter(document.getElementById("cvc"), function(value) {
      return /^[0-9]+$/.test(value);
    });
  }
};
</script>
<style scoped>
.not-work{
    
	height: 24px;
width: 240px;
border-radius: 4px;
/* background-color:var(--main-color); */
color: var(--main-color);
font-family: Poppins;
font-size: 10px;
font-weight: 400;
line-height: 16px;
word-spacing:1.2px;
position: relative;
top: 10px;
text-align: center;

}
.modal {
   position: fixed;;
  left:0;
  top: 0;
  right: 0;
  bottom: 0;
  margin: auto;

  padding: 48px;
  box-sizing: border-box;

  z-index: 5;

  height: 434px;
  width: 434px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  background-color: #ffffff;
}
.modal h1 {
  opacity: 0.8;
  color: #000000;
  font-family: Poppins;
  font-size: 16px !important;
  font-weight: bold;
  line-height: 25px;
  text-align: center;
}

.modal-overlay {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5); /* Black background with opacity */
  z-index: 1;
}
input
{
     border: none;
  padding: 0;
  background: none;
  outline: none;
}
.column-input
{
    width: 100%;
    height: 100%;
   
}
.column-input input
{
    border: none;
	width: 336px;
	height: 56px;
	background-color: #FFFFFF;
	/* box-shadow: 0 1px 0 0 rgba(0,0,0,0.2); */
    padding: 18px;
    border-bottom: 1px solid rgba(0,0,0,0.2)
}
.column-input input::placeholder
{
	opacity: 0.3 !important;
	color: #000000;
	font-family: Poppins;
	font-size: 13px !important;
	font-weight: 500;
	line-height: 20px;
}
.row-input
{
    width: 100%;
}
.row-input div:first-child 
{
    width: 45%;
}
.row-input div:first-child input, span
{
    width: 100% !important;
}
.row-input div:last-child 
{
    width:45%;
}
.row-input div:last-child input, span
{
    width: 100% !important;
}
button
{
     border: none;
  padding: 0;
  background: none;
  outline: none;
}
.button
{
    width: 100%;
    padding-top:25px;
}

.button button:first-child 
{
  

	height: 48px;
	width: 160px;
	border: 1px solid var(--main-color);
	border-radius: 24px;
	background-color: #FFFFFF;

}
.button button:first-child span{
   
	opacity: 0.8;
	color: #000000;
	font-family: Poppins;
	font-size: 13px;
	font-weight: 500;
	line-height: 20px;
	text-align: center;
}
.button button:last-child
{
	height: 48px;
	width: 160px;
	border-radius: 24px;
	background-color: var(--main-color);
}
.button button:last-child span{
    
	color: #FFFFFF;
	font-family: Poppins;
	font-size: 13px;
	font-weight: 500;
	line-height: 20px;
	text-align: center;

}
@media screen and (max-width: 600px)
{
  .modal{
    width: 100%;
    height: 80%;
    
  }
  .column-input
  {
    height: 80%;
  }
  .column-input input
  {
    width: 100%;
  }
  .button
    {
        flex-direction: column-reverse !important;
        justify-content: center !important;
        align-items: center !important;

    }
    .button button:first-child
    {
        width: 100%;
        margin-top: 10px;
    }
    .button button:last-child
    {
        width: 100%;
    }
  
}
</style>



// WEBPACK FOOTER //
// src/components/steps/modals/cardModal.vue